import { render, staticRenderFns } from "./ModuleTables.vue?vue&type=template&id=4193b366&"
import script from "./ModuleTables.vue?vue&type=script&lang=js&"
export * from "./ModuleTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports